// extracted by mini-css-extract-plugin
export default {"row":"AdminList_row__xGIfJ","smallSubmit":"AdminList_smallSubmit__SctZm","addButtonwrapper":"AdminList_addButtonwrapper__f9j+I"};